
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatBadge2(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'badge badge--bottom-left',
                        'key': badge
                    }, '\n              ', _translate(`product_badge_${ badge }`) || badge, '\n            ');
                }
                function repeatI3(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function scopeDiscount4() {
                    var discount = this.calcDiscount(this.price, this.compare_at_price);
                    return _createElement('div', { 'className': 'price' + (this.on_sale ? ' price--on-sale' : '') }, _createElement('div', { 'className': 'price__container' }, !this.on_sale ? _createElement('div', {
                        'className': 'price__regular',
                        'key': '11024'
                    }, _createElement('span', { 'className': 'price-item price-item--regular' }, this.formatPrice(this.price))) : null, this.on_sale ? _createElement('div', {
                        'className': 'price__sale',
                        'key': '11215'
                    }, _createElement('span', { 'className': 'price-item price-item--last price-item--sale' }, this.price_varies ? _createElement('span', { 'key': '11360' }, _translate(`price_from`), ' ') : null, '\n                    ', this.formatPrice(this.min_price || this.price), '\n                  '), _createElement('span', { 'className': 'price-item price-item--regular' }, '\n                     ', _createElement('del', {}, this.formatPrice(this.compare_at_price)))) : null), this.on_sale && discount > 0 ? _createElement('div', {
                        'className': 'cm_sale-percent',
                        'key': '11754'
                    }, '-', discount, '%') : null);
                }
                return _createElement('li', { 'className': 'grid__item' }, _createElement('div', { 'className': 'card-wrapper product-card-wrapper' }, _createElement('div', { 'className': 'card card--standard card--media' }, _createElement('div', { 'className': 'card__inner color-accent-1 gradient ratio' }, _createElement('div', { 'className': 'card__media' }, _createElement('div', { 'className': 'media media--transparent media--hover-effect' }, _createElement('img', {
                    'className': 'motion-reduce',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }))), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('h3', { 'className': 'card__heading' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'card-link'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })))), _createElement.apply(this, [
                    'div',
                    { 'className': 'card__badge top left' },
                    showExactFitBadge && this.Fitment === 'Vehicle Specific' ? _createElement('div', {
                        'className': 'badge badge--bottom-left badge--exact-fit',
                        'key': '875'
                    }, '\n              ', _translate(`product_badge_vehicle_specific`) || 'Específico', '\n            ') : null,
                    this.Fitment === 'Universal Fit' ? _createElement('div', {
                        'className': 'badge badge--bottom-left badge--universal',
                        'key': '1128'
                    }, _createElement('span', { 'className': 'badge-label' }, _translate(`product_badge_universal`) || 'Universal')) : null,
                    this.on_sale ? _createElement('span', {
                        'className': 'badge badge--bottom-left',
                        'key': '1369'
                    }, ' ', _translate(`product_sale_badge`), ' ') : null,
                    this.product_badges ? _map(this.product_badges, repeatBadge2.bind(this)) : null
                ])), _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'card-link card-link-custom'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), !this.out_of_stock ? _createElement('div', {
                    'className': 'quick-add no-js-hidden',
                    'key': '1919'
                }, this.variant_ids.length === 1 ? _createElement('convermax-product-form', { 'key': '1993' }, _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'id': 'quick-add-cm_results__product-grid' + this.id,
                    'acceptCharset': 'UTF-8',
                    'className': 'form',
                    'encType': 'multipart/form-data',
                    'noValidate': 'novalidate',
                    'data-type': 'add-to-cart-form'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'form_type',
                    'value': 'product'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'utf8',
                    'value': '\u2713'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids
                }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                    'type': 'hidden',
                    'name': 'properties[Fitment]',
                    'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                    'key': '2499'
                }) : null, _createElement('button', {
                    'id': 'quick-add-cm_results__product-grid' + this.id + '-submit',
                    'type': 'submit',
                    'name': 'add',
                    'className': 'quick-add__submit button button--full-width button--secondary',
                    'aria-haspopup': 'dialog',
                    'aria-labelledby': 'quick-add-cm_results__product-grid' + this.id + '-submit title-cm_results__product-grid-' + this.id,
                    'aria-live': 'polite',
                    'data-sold-out-message': 'true'
                }, _createElement('span', {}, _translate(`product_add_to_cart`)), _createElement('span', { 'className': 'sold-out-message hidden' }, _translate(`product_out_of_stock`)), _createElement('span', { 'className': 'icon-add' }, [_createElement('svg', {
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '16',
                        'height': '16',
                        'viewBox': '0 0 16 16',
                        'fill': 'none',
                        'key': '32780'
                    }, _createElement('g', { 'clipPath': 'url(#clip0_3628_301440)' }, _createElement('path', {
                        'd': 'M5.33073 14.6673C5.69892 14.6673 5.9974 14.3688 5.9974 14.0007C5.9974 13.6325 5.69892 13.334 5.33073 13.334C4.96254 13.334 4.66406 13.6325 4.66406 14.0007C4.66406 14.3688 4.96254 14.6673 5.33073 14.6673Z',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M1.36719 1.36719H2.70052L4.47385 9.64719C4.53891 9.95043 4.70763 10.2215 4.951 10.4138C5.19436 10.606 5.49712 10.7074 5.80719 10.7005H12.3272C12.6306 10.7 12.9248 10.596 13.1612 10.4057C13.3976 10.2154 13.5619 9.95021 13.6272 9.65385L14.7272 4.70052H3.41385',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_3628_301440' }, _createElement('rect', {
                        'width': '16',
                        'height': '16',
                        'fill': 'white'
                    }))))]), _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                        'aria-hidden': 'true',
                        'focusable': 'false',
                        'className': 'spinner',
                        'viewBox': '0 0 66 66',
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'key': '45640'
                    }, _createElement('circle', {
                        'className': 'path',
                        'fill': 'none',
                        'strokeWidth': '6',
                        'cx': '33',
                        'cy': '33',
                        'r': '30'
                    }))])), _createElement('input', {
                    'type': 'hidden',
                    'name': 'product-id',
                    'value': this.id
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'section-id',
                    'value': 'cm_results__product-grid'
                }))) : null, this.variant_ids.length > 1 ? [
                    _createElement('convermax-modal-opener', {
                        'data-modal': '#QuickAdd-' + this.id,
                        'key': '50611'
                    }, _createElement('button', {
                        'id': 'cm_results__product-grid' + this.id + '-submit',
                        'type': 'submit',
                        'name': 'add',
                        'className': 'quick-add__submit button button--full-width button--secondary',
                        'aria-haspopup': 'dialog',
                        'aria-labelledby': 'cm_results__product-grid' + this.id + '-submit cm_results__product-grid-' + this.id,
                        'data-product-url': this.url
                    }, '\n                ', _translate(`product_add_to_cart`), '\n                ', [_createElement('svg', {
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'width': '16',
                            'height': '16',
                            'viewBox': '0 0 16 16',
                            'fill': 'none',
                            'key': '55630'
                        }, _createElement('g', { 'clipPath': 'url(#clip0_3628_301440)' }, _createElement('path', {
                            'd': 'M5.33073 14.6673C5.69892 14.6673 5.9974 14.3688 5.9974 14.0007C5.9974 13.6325 5.69892 13.334 5.33073 13.334C4.96254 13.334 4.66406 13.6325 4.66406 14.0007C4.66406 14.3688 4.96254 14.6673 5.33073 14.6673Z',
                            'stroke': 'black',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }), _createElement('path', {
                            'd': 'M12.6667 14.6673C13.0349 14.6673 13.3333 14.3688 13.3333 14.0007C13.3333 13.6325 13.0349 13.334 12.6667 13.334C12.2985 13.334 12 13.6325 12 14.0007C12 14.3688 12.2985 14.6673 12.6667 14.6673Z',
                            'stroke': 'black',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }), _createElement('path', {
                            'd': 'M1.36719 1.36719H2.70052L4.47385 9.64719C4.53891 9.95043 4.70763 10.2215 4.951 10.4138C5.19436 10.606 5.49712 10.7074 5.80719 10.7005H12.3272C12.6306 10.7 12.9248 10.596 13.1612 10.4057C13.3976 10.2154 13.5619 9.95021 13.6272 9.65385L14.7272 4.70052H3.41385',
                            'stroke': 'black',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_3628_301440' }, _createElement('rect', {
                            'width': '16',
                            'height': '16',
                            'fill': 'white'
                        }))))], _createElement('div', { 'className': 'loading-overlay__spinner hidden' }, [_createElement('svg', {
                            'aria-hidden': 'true',
                            'focusable': 'false',
                            'className': 'spinner',
                            'viewBox': '0 0 66 66',
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'key': '68250'
                        }, _createElement('circle', {
                            'className': 'path',
                            'fill': 'none',
                            'strokeWidth': '6',
                            'cx': '33',
                            'cy': '33',
                            'r': '30'
                        }))]))),
                    _createElement('convermax-quick-add-modal', {
                        'id': 'QuickAdd-' + this.id,
                        'key': '50613',
                        'class': 'quick-add-modal quick-add-modal__b2b'
                    }, _createElement('div', {
                        'role': 'dialog',
                        'aria-label': 'Choose options for ' + this.removeHTML(this.title),
                        'aria-modal': 'true',
                        'className': 'quick-add-modal__content global-settings-popup',
                        'tabIndex': '-1'
                    }, _createElement('button', {
                        'id': 'ModalClose-' + this.id,
                        'type': 'button',
                        'className': 'quick-add-modal__toggle',
                        'aria-label': 'Close'
                    }, [_createElement('svg', {
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'aria-hidden': 'true',
                            'focusable': 'false',
                            'className': 'icon icon-close',
                            'fill': 'none',
                            'viewBox': '0 0 18 17',
                            'key': '75590'
                        }, _createElement('path', {
                            'd': 'M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z',
                            'fill': 'currentColor'
                        }))]), _createElement('div', {
                        'id': 'QuickAddInfo-' + this.id,
                        'className': 'quick-add-modal__content-info rocket-main-product'
                    })))
                ] : null) : null, _createElement('div', { 'className': 'card__wishlist' }, _createElement('button', {
                    'aria-label': 'Add to Wishlist',
                    'data-with-epi': 'true',
                    'className': 'swym-button swym-add-to-wishlist-view-product product_' + this.id + ' swym-icontext swym-heart swym-loaded',
                    'data-product-swatch-id': this.id,
                    'data-swaction': 'addToWishlist',
                    'data-product-id': this.id,
                    'data-variant-id': this.variant_ids[0],
                    'data-product-url': window.location.protocol + '//' + window.location.host + this.url
                }, [_createElement('svg', {
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '22',
                        'height': '22',
                        'viewBox': '0 0 22 22',
                        'fill': 'none',
                        'key': '86410'
                    }, _createElement('path', {
                        'd': 'M16.2137 12.7074C17.387 11.5719 18.5762 10.2107 18.5762 8.42963C18.5762 7.2951 18.1198 6.20703 17.3076 5.40479C16.4953 4.60255 15.3936 4.15186 14.2449 4.15186C12.8589 4.15186 11.8824 4.54074 10.7012 5.70741C9.51992 4.54074 8.54342 4.15186 7.15742 4.15186C6.0087 4.15186 4.90703 4.60255 4.09477 5.40479C3.2825 6.20703 2.82617 7.2951 2.82617 8.42963C2.82617 10.2185 4.00742 11.5796 5.18867 12.7074L10.7012 18.1519L16.2137 12.7074Z',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }))]))), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('div', { 'className': 'card__top--infor' }, _createElement('div', { 'className': 'card__vendor' }, this.vendor_image ? _createElement('img', {
                    'src': this.imageOrDefault(this.resizeImage(this.vendor_image)),
                    'alt': this.removeHTML(this.vendor),
                    'onError': this.onImageError,
                    'key': '9489'
                }) : null, !this.vendor_image ? _createElement('span', Object.assign({}, { 'key': '9668' }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null), this.sku ? _createElement('div', {
                    'className': 'card__sku',
                    'key': '9861'
                }, _createElement('span', {}, 'Sku:'), _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } })) : null), _createElement('h3', { 'className': 'card__heading h5' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'card-link'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '103570'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI3.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], _createElement('div', { 'className': 'card-information' }, scopeDiscount4.apply(this, [])))), _createElement('div', { 'className': 'card__content--status' }, _createElement('div', { 'className': 'card-info-status__product' }, this.rocket_procduct_pendiente ? [
                    _createElement('span', {
                        'className': 'icon',
                        'key': '120141'
                    }, [_createElement('svg', {
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'width': '14',
                            'height': '14',
                            'viewBox': '0 0 14 14',
                            'fill': 'none',
                            'key': '121120'
                        }, _createElement('path', {
                            'd': 'M7 3.5V7L9.33333 8.16667',
                            'stroke': '#ECB621',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }), _createElement('path', {
                            'd': 'M9.33261 12.3429C8.28411 12.801 7.12405 12.9405 5.99683 12.7443C4.8696 12.548 3.82499 12.0246 2.99298 11.2391C2.16098 10.4537 1.57834 9.44092 1.31758 8.32685C1.05681 7.21278 1.12944 6.04662 1.52642 4.97351C1.92339 3.9004 2.62719 2.96773 3.55022 2.29158C4.47324 1.61543 5.57473 1.22566 6.7176 1.17078C7.86046 1.1159 8.99423 1.39833 9.9778 1.98292C10.9614 2.56751 11.7513 3.42845 12.2493 4.45858',
                            'stroke': '#ECB621',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }), _createElement('path', {
                            'd': 'M11.6641 6.70801V10.208',
                            'stroke': '#ECB621',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }), _createElement('path', {
                            'd': 'M11.6641 12.542H11.6707',
                            'stroke': '#ECB621',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }))]),
                    _createElement('span', {
                        'className': 'text',
                        'key': '120143'
                    }, _translate(`product_stock_pending`))
                ] : null, !this.rocket_procduct_pendiente ? [
                    !this.out_of_stock ? [
                        _createElement('span', {
                            'className': 'icon',
                            'key': '132801'
                        }, [_createElement('svg', {
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'fill': 'none',
                                'key': '133700'
                            }, _createElement('path', {
                                'd': 'M13.3008 4.5498L6.42578 11.4248L3.30078 8.2998',
                                'stroke': '#0CB73F',
                                'strokeWidth': '1.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))]),
                        _createElement('span', {
                            'className': 'text',
                            'key': '132803'
                        }, _translate(`product_stock_available`))
                    ] : null,
                    this.out_of_stock ? [
                        _createElement('span', {
                            'className': 'icon',
                            'key': '137811'
                        }, [_createElement('svg', {
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'width': '14',
                                'height': '14',
                                'viewBox': '0 0 14 14',
                                'fill': 'none',
                                'key': '138700'
                            }, _createElement('path', {
                                'd': 'M10.5 3.5L3.5 10.5',
                                'stroke': '#EF4A4A',
                                'strokeWidth': '1.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'd': 'M3.5 3.5L10.5 10.5',
                                'stroke': '#EF4A4A',
                                'strokeWidth': '1.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))]),
                        _createElement('span', {
                            'className': 'text',
                            'key': '137813'
                        }, _translate(`product_out_of_stock`))
                    ] : null
                ] : null), this.variant_ids?.length > 1 ? _createElement('div', {
                    'className': 'card-info-status__color',
                    'key': '14398'
                }, _createElement('a', { 'href': this.url }, _createElement('span', { 'className': 'text' }, '+ ', _translate(`product_options`)))) : null))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []